import { AccountSelectionState, Actions, ActionTypes } from './types';

export function reducer(
  state: AccountSelectionState,
  action: Actions
): AccountSelectionState {
  switch (action.type) {
    case ActionTypes.setAccounts:
      return {
        ...state,
        accounts: action.payload
      };
    case ActionTypes.setSelectedFromAccountIban:
      if (!state.accounts) return state;
      const selectedFromAccount = state.accounts.find(
        ({ iban }) => iban === action.payload
      );
      return {
        ...state,
        selectedFromAccount,
        selectedFromAccountIban: action.payload
      };
    case ActionTypes.setSelectedToAccountIban:
      if (!state.accounts) return state;
      const selectedToAccount = state.accounts.find(
        ({ iban }) => iban === action.payload
      );
      return {
        ...state,
        selectedToAccount,
        selectedToAccountIban: action.payload
      };

    case ActionTypes.switchSelectedAccounts:
      return {
        ...state,
        selectedFromAccount: state.selectedToAccount,
        selectedToAccount: state.selectedFromAccount,
        selectedFromAccountIban: state.selectedToAccountIban,
        selectedToAccountIban: state.selectedFromAccountIban
      };

    case ActionTypes.setAmounts:
      return {
        ...state,
        amounts: {
          ...state.amounts,
          [action.payload.type]: action.payload.amount
        }
      };

    case ActionTypes.setDescription:
      return {
        ...state,
        description: action.payload
      };

    case ActionTypes.setQuoteInfo:
      return {
        ...state,
        ...action.payload
      };

    case ActionTypes.setTradeId:
      return {
        ...state,
        tradeId: action.payload
      };

    case ActionTypes.setDirection:
      return {
        ...state,
        direction: action.payload
      };

    default:
      return state;
  }
}
